import { AxiosError, AxiosResponse } from 'axios'
import { camelize } from 'casing'
import {
  startLoading,
  stopLoading,
  LoadingTypes,
  errorLogger,
} from '@labrav/common'

import { getBuyerMeteringsAPI } from '../../api/marketplace/index'
import type { AppDispatch, RootState } from '../../store/types'
import { BuyerMeteringsActionTypes, Meterings } from './types'

export { BuyerMeteringsActionTypes }

export const getBuyerMeterings =
  ({ partnerId, buyerId }: { partnerId: string; buyerId: string }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.BUYERS_OVERVIEW))
    try {
      const response = await getBuyerMeteringsAPI({ partnerId, buyerId })
      const meterings = camelize(response?.data)
      await dispatch(setBuyerMeterings(meterings as Meterings))
    } catch (error: unknown) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      const globalState = getState()
      errorLogger({ globalState: globalState as never })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.BUYERS_OVERVIEW))
    }
  }

export const setBuyerMeterings = (meterings: Meterings) => ({
  type: BuyerMeteringsActionTypes.SET_BUYER_METERINGS,
  payload: meterings,
})
